export const RESIZER_ATTRIBUTE = 'data-resizer';

export type ResizerAttributeProps = { [RESIZER_ATTRIBUTE]?: string };

export const RESIZER_ATTRS: ResizerAttributeProps = { [RESIZER_ATTRIBUTE]: '' };
